import Notification from '../core/Notification';
import PropTypes from 'prop-types';
import React from 'react';
import ProjectImport from '../core/project/ProjectImport';
import VersionWarning from '../core/VersionWarning';

class OntologyImport extends React.Component {

    render() {

        const { id, graph, project, baseLink, data, projectType } = this.props;

        if (data.isVersionOfProject) return <VersionWarning />;
        if (projectType && projectType !== data.type) return <Notification text="You are trying to view an incorrect project type." />;

        return (
            <ProjectImport
                id={id}
                additionalExtensions={[".owl", ".xml"]}
                graph={graph}
                issueManagement={true}
                importApproachManagement={true}
                importManagement={true}
                project={project}
                baseLink={baseLink} />
        );
    }
}

OntologyImport.propTypes = {
    id: PropTypes.string.isRequired,
    data: PropTypes.object.isRequired,
    projectType: PropTypes.string.isRequired,
    graph: PropTypes.string.isRequired,
    project: PropTypes.string.isRequired,
    baseLink: PropTypes.string.isRequired
};

export default OntologyImport;